import React from "react";
import Section from "./Section";
import img1 from "../../img/hi.jpg";

export default function HTML_Background_Images() {
  return (
    <div className="tutorial-container">
      {/* 🔹 Title */}
      <h1 className="tutorial-title">🖼️ HTML Background Images</h1>

      {/* 🔹 Introduction */}
      <p className="tutorial-intro">
        Background images in HTML are added using the{" "}
        <code className="highlight_code_1">background-image</code> CSS property.
        You can apply background images to any HTML element such as{" "}
        <code>div</code>, <code>section</code>, or the entire webpage.
      </p>

      {/* 🔹 Key Points */}
      <div
        className="Key_point_container"
        style={{
          background: "linear-gradient(135deg, #fef9f9, #fee2e2)",
          borderRadius: "12px",
          padding: "1rem",
          marginBottom: "1.5rem",
        }}
      >
        <h3
          style={{
            color: "#dc2626",
            fontWeight: 700,
            fontSize: "1.5rem",
            marginBottom: "0.5rem",
          }}
        >
          📜 Background Image Properties
        </h3>
        <ul className="tutorial-list-points">
          <li>
            <code className="highlight_code_1">background-image</code> — Set the
            image path.
          </li>
          <li>
            <code className="highlight_code_1">background-repeat</code> — Repeat
            or stop repeating the image.
          </li>
          <li>
            <code className="highlight_code_1">background-size</code> — Control
            how the image fits (cover, contain, stretch).
          </li>
          <li>
            <code className="highlight_code_1">background-position</code> —
            Align image inside the element.
          </li>
        </ul>
      </div>

      {/* Section 1️⃣ — Background Image on an Element */}
      <Section
        title="1️⃣ Background Image on an HTML Element"
        html={`<div style="
  height:150px; 
  width:300px;
  background-image:url(${img1});
  background-position:center;
  background-size:auto;
">
  Background Image Example
</div>`}
        description="Applies a simple background image to a div element using the background-image property."
      />

      {/* Section 2️⃣ — Background Repeat */}
      <Section
        title="2️⃣ Background Repeat"
        html={`<div style="
  height:150px; 
  width:300px;
  background-image:url(${img1});
  background-repeat:repeat;
  background-size:100px;
">
  Repeating Background
</div>`}
        description="The background-repeat property repeats the image horizontally and vertically to fill the element."
      />

      {/* Section 3️⃣ — Background Cover */}
      <Section
        title="3️⃣ Background Cover"
        html={`<div style="
  height:300px; 
  width:100%;
  background-image:url(${img1});
  background-size:cover;
  background-position:center;
">
  Cover Background
</div>`}
        description="The cover value makes the background image fully cover the element while maintaining aspect ratio."
      />

      {/* Section 4️⃣ — Background Stretch (100% 100%) */}
      <Section
        title="4️⃣ Background Stretch"
        html={`<div style="
  height:150px; 
  width:300px;
  background-image:url(${img1});
  background-size:100% 100%;
  background-repeat:no-repeat;
">
  Stretched Background
</div>`}
        description="The background-size: 100% 100% stretches the image to fill the element completely — may distort the image."
      />

      {/* Summary */}
      <div
        style={{
          background: "linear-gradient(135deg, #fef9c3, #fde68a)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2>📘 Summary — HTML Background Images</h2>
        <ul className="tutorial-list-points">
          <li>
            <b>Background Image</b> — Adds an image to an element.
          </li>
          <li>
            <b>Background Repeat</b> — Repeats the image across the element.
          </li>
          <li>
            <b>Background Cover</b> — Makes the background fully cover the box.
          </li>
          <li>
            <b>Background Stretch</b> — Stretches the image to fit the element.
          </li>
        </ul>
      </div>
    </div>
  );
}
